import { createContext, useContext, useEffect, useState } from 'react';

const STORAGE_KEY = 'ufomt-theme';

const ThemeContext = createContext({ theme: 'light', toggleTheme: () => {} });

// Saved choice wins; otherwise follow the OS preference; default to light.
const getInitialTheme = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored === 'light' || stored === 'dark') return stored;
    } catch (e) {
        // localStorage can throw in private-mode / sandboxed contexts — fall through.
    }
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        return 'dark';
    }
    return 'light';
};

export function ThemeProvider({ children }) {
    const [theme, setTheme] = useState(getInitialTheme);

    // Bootstrap 5.3 reads data-bs-theme on the root and re-themes the body + all components.
    useEffect(() => {
        document.documentElement.setAttribute('data-bs-theme', theme);
        try {
            localStorage.setItem(STORAGE_KEY, theme);
        } catch (e) {
            // Persisting is best-effort; ignore storage failures.
        }
    }, [theme]);

    const toggleTheme = () => setTheme((t) => (t === 'dark' ? 'light' : 'dark'));

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
}

export function useTheme() {
    return useContext(ThemeContext);
}
